import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin(
	"hospitalGroup",
	api.hospitalGroups
)({
	actions: {
		async hospitalGroupInsert(context, group) {
			context.commit(`hospitalGroupInsertStart`, group);

			try {
				const { users } = group;
				const _group = await api.hospitalGroups("post", group);

				if (users) {
					const { hospitalid } = group;
					users.forEach((userid) => {
						api.hospitalGroupUsers("post", {
							hospitalid,
							groupid: _group.id,
							userid
						});
					});
				}

				context.commit(`hospitalGroupInsertSuccess`, _group);
				return _group;
			} catch (error) {
				context.commit(`hospitalGroupInsertFailure`, group);
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				throw error;
			}
		},
		async hospitalGroupsLoad(context, group) {
			context.commit(`hospitalGroupLoadStart`);
			try {
				const things = await api.hospitalGroups("get", group);

				context.commit(`hospitalGroupsLoadSuccess`, things, group);
			} catch (error) {
				context.commit(`hospitalGroupsLoadFailure`, error.message);
				throw error;
			}
		},
		async hospitalGroupLoad(context, { id, force }) {
			// Do we already have the user?
			if (!force && context.getters[`hospitalGroupGet`](id)) return;

			context.commit(`hospitalGroupLoadStart`);
			try {
				const thing = await api.hospitalGroups("get", {
					id
				});
				context.commit(`hospitalGroupLoadSuccess`, thing);
			} catch (error) {
				context.commit(`hospitalGroupLoadFailure`, error.message);
				throw error;
			}
		},
		async hospitalGroupUpdate(context, { group }) {
			context.commit(`hospitalGroupLoadStart`);
			try {
				const { users } = group;
				const _thing = await api.hospitalGroups("PUT", group);
				// we only want to run the media query if there something to sent
				if (users) {
					const { hospitalid, id } = group;
					users.forEach((userid) => {
						api.hospitalGroupUsers("post", {
							hospitalid,
							groupid: id,
							userid
						});
					});
				}
				context.commit("hospitalGroupLoadSuccess", _thing);
			} catch (error) {
				context.commit(`hospitalGroupLoadFailure`, error.message);
				throw error;
			}
		},
		async hospitalGroupUserRemove(
			context,
			{ hospitalid, groupid, userid }
		) {
			await api.hospitalGroupUsers("delete", {
				hospitalid,
				groupid,
				userid
			});
		}
	}
});
